export default function Contact() {
  return (
    <section id="contact" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              商务合作
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500">
              如果您是影视平台方希望接入青青草视频聚合，或有其他合作意向，欢迎通过以下方式与我们取得联系
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">合作邮箱</div>
                  <span className="text-sm text-foreground-500">contact@qingqingcao.com</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shake-hands-line text-accent-600"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">平台接入</div>
                  <span className="text-sm text-foreground-500">提交平台信息即可</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-secondary-600"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">响应时间</div>
                  <span className="text-sm text-foreground-500">1-2个工作日</span>
                </div>
              </div>
            </div>

            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9lpk7sit35ii3jdlbb0"
              method="POST"
              className="space-y-4"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">您的称呼</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="请输入您的称呼"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="请输入您的邮箱"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">平台名称</label>
                <input
                  type="text"
                  name="platform"
                  placeholder="请输入您的影视平台名称"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">合作说明</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="请简要描述您的合作意向或平台特点（500字以内）"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                readOnly
                aria-hidden="true"
                className="spam-guard"
              />
              <button
                type="submit"
                className="w-full py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                提交合作申请
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}